var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.12517 0H9.81183L15.479 5.90705V17.3963C15.479 18.8356 14.3146 20 12.8803 20H3.12517C1.6859 20 0.521484 18.8356 0.521484 17.3963V2.60369C0.521459 1.16441 1.68587 0 3.12517 0Z",
    fill: "#E5252A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80664 0V5.86207H15.4788L9.80664 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41504 14.9227V11.2695H4.96927C5.35408 11.2695 5.65893 11.3745 5.88881 11.5894C6.1187 11.7993 6.23365 12.0841 6.23365 12.4389C6.23365 12.7938 6.1187 13.0786 5.88881 13.2885C5.65893 13.5034 5.35408 13.6084 4.96927 13.6084H4.34957V14.9227H3.41504ZM4.34957 12.8138H4.86432C5.00424 12.8138 5.11419 12.7838 5.18917 12.7138C5.26412 12.6489 5.30412 12.5589 5.30412 12.439C5.30412 12.319 5.26414 12.2291 5.18917 12.1641C5.11422 12.0941 5.00427 12.0642 4.86432 12.0642H4.34957V12.8138ZM6.61843 14.9227V11.2695H7.91279C8.16766 11.2695 8.40755 11.3045 8.63242 11.3795C8.8573 11.4544 9.06221 11.5594 9.24211 11.7043C9.42203 11.8442 9.56696 12.0341 9.6719 12.274C9.77184 12.5139 9.82683 12.7888 9.82683 13.0986C9.82683 13.4035 9.77187 13.6783 9.6719 13.9182C9.56696 14.1581 9.42203 14.348 9.24211 14.4879C9.06219 14.6328 8.8573 14.7378 8.63242 14.8128C8.40755 14.8877 8.16766 14.9227 7.91279 14.9227H6.61843ZM7.53298 14.1281H7.80284C7.94776 14.1281 8.0827 14.1131 8.20764 14.0781C8.32757 14.0432 8.44252 13.9882 8.55247 13.9132C8.65741 13.8383 8.74237 13.7333 8.80234 13.5934C8.8623 13.4535 8.8923 13.2885 8.8923 13.0986C8.8923 12.9037 8.8623 12.7388 8.80234 12.5989C8.74237 12.459 8.65741 12.354 8.55247 12.279C8.44252 12.2041 8.32759 12.1491 8.20764 12.1141C8.0827 12.0792 7.94776 12.0641 7.80284 12.0641H7.53298V14.1281ZM10.2966 14.9227V11.2695H12.8953V12.0641H11.2311V12.6488H12.5605V13.4385H11.2311V14.9227H10.2966Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdfIcon.836127d53d1447dfa6563c9aad8636f9.svg";
export { ForwardRef as ReactComponent };